const SCRIPT_ID = "waajo-google-maps-script";
const CALLBACK_NAME = "vueGoogleMapsInit";

let loaderPromise = null;
let loadedKey = "";
let authFailure = false;
let authFailureSubscribers = [];

function createLoaderError(code, message) {
  const error = new Error(message);
  error.code = code;
  return error;
}

function notifyAuthFailure() {
  authFailure = true;
  authFailureSubscribers.slice().forEach(handler => {
    try {
      handler();
    } catch (error) {
      // Jangan biarkan handler komponen memutus callback Google Maps.
    }
  });
}

function installAuthFailureHandler() {
  if (
    typeof window === "undefined" ||
    window.__waajoGmapAuthHandlerInstalled
  ) {
    return;
  }

  window.__waajoGmapAuthHandlerInstalled = true;
  const previousHandler = window.gm_authFailure;

  window.gm_authFailure = function() {
    notifyAuthFailure();
    if (typeof previousHandler === "function") {
      try {
        previousHandler();
      } catch (error) {
        // Callback sebelumnya tidak boleh menghentikan penanganan error.
      }
    }
  };
}

function installCallbackWrapper() {
  if (
    typeof window === "undefined" ||
    window.__waajoGmapCallbackWrapped
  ) {
    return;
  }

  const pluginInit = window[CALLBACK_NAME];

  window[CALLBACK_NAME] = function() {
    if (typeof pluginInit === "function") {
      pluginInit();
    }

    if (typeof window.__waajoGmapResolve === "function") {
      const resolve = window.__waajoGmapResolve;
      window.__waajoGmapResolve = null;
      resolve(window.google);
    }
  };

  window.__waajoGmapCallbackWrapped = true;
}

function clearFailedScript() {
  const script = document.getElementById(SCRIPT_ID);
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }
  window.__waajoGmapResolve = null;
  loadedKey = "";
  loaderPromise = null;
}

export function loadGoogleMaps(apiKey) {
  installAuthFailureHandler();
  installCallbackWrapper();

  const key = String(apiKey || "").trim();

  if (!key) {
    return Promise.reject(
      createLoaderError(
        "missing-key",
        "Google Maps API Key belum tersedia."
      )
    );
  }

  if (typeof window === "undefined") {
    return Promise.reject(
      createLoaderError(
        "browser-unavailable",
        "Google Maps hanya dapat dimuat di browser."
      )
    );
  }

  if (window.google && window.google.maps) {
    if (loadedKey && loadedKey !== key) {
      return Promise.reject(
        createLoaderError(
          "key-changed",
          "API Key berubah setelah Google Maps dimuat."
        )
      );
    }
    return Promise.resolve(window.google);
  }

  if (loaderPromise) {
    if (loadedKey && loadedKey !== key) {
      return Promise.reject(
        createLoaderError(
          "key-changed",
          "Google Maps sedang dimuat dengan API Key yang berbeda."
        )
      );
    }
    return loaderPromise;
  }

  const existingScript = document.getElementById(SCRIPT_ID);
  if (existingScript) {
    clearFailedScript();
  }

  loadedKey = key;

  loaderPromise = new Promise((resolve, reject) => {
    window.__waajoGmapResolve = function(google) {
      loaderPromise = null;
      resolve(google);
    };

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      encodeURIComponent(key) +
      "&libraries=places&callback=" +
      CALLBACK_NAME;

    script.onerror = function() {
      clearFailedScript();
      reject(
        createLoaderError(
          "script-error",
          "Google Maps gagal dimuat dari server Google."
        )
      );
    };

    document.head.appendChild(script);
  });

  return loaderPromise;
}

export function isGoogleMapsAuthFailed() {
  return authFailure;
}

export function subscribeGoogleMapsAuthFailure(handler) {
  if (typeof handler !== "function") {
    return function() {};
  }

  authFailureSubscribers.push(handler);

  return function() {
    authFailureSubscribers = authFailureSubscribers.filter(
      item => item !== handler
    );
  };
}



// WEBPACK FOOTER //
// ./src/utils/googleMapsLoader.js